module.exports = __webpack_public_path__ + "img/VIRTUAL_ACCOUNT_BANK_BNC.a955087b.png";